module.exports = __webpack_public_path__ + "img/ey-logo-blue.d5f66a2e.svg";